import 'bootstrap';
import 'slick-carousel';
import $ from 'jquery';
import domify from 'domify';
import ContactForm from 'auth0-contact-form';
import container from 'modules/section-content';
import page from 'modules/ab-page-js';
import splash from './view/index.pug';
import metadata from './metadata.json';

const metricsLib = window.metricsLib;

export default function register() {
  page('/forrester-total-economic-impact', render, snippets);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);
  next();
}

function contactFormModals() {
  // Contact Sales Form
  const salesContactFormOptions = {
    onModalOpen() {
      metricsLib.track('click:contact-sales');
    },
    onFormSuccess(metricsData) {
      metricsLib.track('register:lead:singl-sign-on-contact-form', metricsData);
    },
    onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:singl-sign-on-contact-form', metricsData);
    },
    source: 'singl-sign-on'
  };

  /* eslint-env browser */
  document.querySelectorAll('.open-contact-form-modal').forEach(element => {
    element.addEventListener(
      'click',
      () => {
        const salesContactForm = new ContactForm(salesContactFormOptions);
        salesContactForm.show({ includePhoneField: true });
      },
      false
    );
  });
}

function slickCarousel() {
  $('.report__slider').slick({
    autoplay: true,
    autoplaySpeed: 10000,
    speed: 500,
    arrows: false,
    fade: true,
    dots: true,
    cssEase: 'linear'
  });
}

function snippets(ctx, next) {
  contactFormModals();
  slickCarousel();

  next();
}



// WEBPACK FOOTER //
// ./src/pages/tei/client.js